import http from '../../config/axios';

export const callVacationByUser = async() => {
    const res = await http.get('/vacation/account')
    return res.data;
}